import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Cómo Funciona Tu Mente Bajo Presión',
  subtitle: 'Entendé por qué te bloqueás y cómo evitarlo',
  accent: 'border-l-blue-500',
  items: ['Qué pasa en tu mente en situaciones de presión', 'Identificación de microbloqueos en tiempo real', 'Diferencia entre saber y poder actuar', 'Factores que generan duda clínica', 'Reconocimiento de patrones mentales repetitivos', 'Base para desarrollar claridad mental en guardia']
}, {
  icon: '🔴',
  title: 'Tomo 2 — RESET Mental en Segundos',
  subtitle: 'Interrumpí el bloqueo en tiempo real',
  accent: 'border-l-red-500',
  items: ['Protocolo RESET paso a paso', 'Cómo cortar la duda en segundos', 'Técnicas de reenfoque inmediato', 'Recuperación rápida del control mental', 'Aplicación en situaciones clínicas reales', 'Automatización del reset bajo presión']
}, {
  icon: '🟢',
  title: 'Tomo 3 — Pensamiento Clínico Simplificado',
  subtitle: 'Pensá más claro sin sobrecargarte',
  accent: 'border-l-green-500',
  items: ['Estructura simple de pensamiento clínico', 'Cómo ordenar información rápidamente', 'Reducción del sobreanálisis', 'Priorización clara en situaciones reales', 'Enfoque en lo relevante (sin ruido mental)', 'Toma de decisiones con lógica práctica']
}, {
  icon: '🟠',
  title: 'Tomo 4 — Decisión sin Parálisis',
  subtitle: 'Actuá rápido sin dudar',
  accent: 'border-l-orange-500',
  items: ['Modelo de decisión rápida en guardia', 'Cómo pasar de pensar → actuar', 'Eliminación de la parálisis por análisis', 'Claridad en momentos críticos', 'Elección de acciones seguras y efectivas', 'Flujo mental para decidir bajo presión']
}, {
  icon: '🟣',
  title: 'Tomo 5 — Operar en Guardia sin Colapsar',
  subtitle: 'Sostené el rendimiento en situaciones exigentes',
  accent: 'border-l-purple-500',
  items: ['Gestión del tiempo en guardia', 'Manejo de múltiples tareas sin bloquearte', 'Control del ritmo en guardia', 'Prevención del colapso mental', 'Continuidad operativa durante el turno', 'Respuesta estable en situaciones intensas']
}, {
  icon: '🟡',
  title: 'Tomo 6 — Recuperación y Control Emocional',
  subtitle: 'Cerrá el turno sin arrastrar carga mental',
  accent: 'border-l-yellow-400',
  items: ['Técnicas de cierre mental post-guardia', 'Liberación de carga emocional', 'Regulación del estrés acumulado', 'Recuperación rápida entre turnos', 'Separación trabajo–vida personal', 'Construcción de estabilidad emocional sostenida']
}];
const features = ['Guías paso a paso', 'Protocolos claros', 'Ejercicios prácticos', 'Plantillas clínicas', 'Aplicación directa en guardia'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-296">
      <div className="max-w-xl mx-auto" data-id="element-297">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-298">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-299">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-300">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-301">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-302">
                  <span className="text-2xl flex-shrink-0" data-id="element-303">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-304">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-305">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-306">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-307" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-308" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-309">
                    <div className="space-y-2" data-id="element-310">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-311">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-312" />
                          <span className="text-xs text-gray-400" data-id="element-313">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-314">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-315">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-316">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-317">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-318" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-319">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}